export default __webpack_public_path__ + "static/media/akustikdecken5.2f42ef5a.jpg";